import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { IRecording, ISiteRecordings } from "./recordings.state";
import { ISensor } from "../../common/models/sensor.interface";
import { DateRange } from "@angular/material/datepicker";
import { IAlertBookmark } from "../models/alert-bookmark.model";
import { IAlert } from "../../common/models/alert.model";
import { IRecordingsPopupFilter } from "../../common/models/recordings-popup.model";

export const RecordingsActions = createActionGroup({
    source: 'Recordings',
    events: {
        loadRecordings: props<{ sensors: ISensor[] }>(),
        loadRecordingsSuccess: props<{ recordings: ISiteRecordings[] }>(),
        loadRecordingsFailure: props<{ error: Error }>(),
        loadMediaMTXRecordings: props<{ sensors: ISensor[], dateRange: DateRange<Date> }>(),
        loadMediaMTXRecordingsSuccess: props<{ recordings: IRecording[] }>(),
        loadMediaMTXRecordingsFailure: props<{ error: Error }>(),
        setSelectedCameras: props<{ sensors: ISensor[] }>(),
        setSelectedDateRange: props<{ dateRange: DateRange<Date> }>(),
        setMediaControls: props<{ enabled: boolean }>(),
        setMediaControlsSuccess: props<{ enabled: boolean }>(),
        setShowUnscheduledCams: props<{ enabled: boolean }>(),
        setShowUnscheduledCamsSuccess: props<{ enabled: boolean }>(),
        loadRecordingSettings: emptyProps(),
        loadRecordingSettingsSuccess: props<{ mediaControls: boolean, unscheduledCams: boolean }>(),
        clearState: emptyProps(),
        loadAlertBookmarks: props<{ cameraIds: string[]; dateRange: DateRange<Date> }>(),
        loadAlertBookmarksSuccess: props<{ bookmarks: IAlertBookmark[] }>(),
        loadAlertBookmarksFailure: props<{ error: Error }>(),
        toggleAlertBookmarks: props<{ enabled: boolean }>(),
        clearAlertBookmarks: emptyProps(),
        openInvestigatePopup: props<{ alert: IAlert }>(),
        openInvestigatePopupSuccess: props<{ filter: IRecordingsPopupFilter }>(),
        openInvestigatePopupFailure: props<{ error: Error }>(),
        investigatePopupFilterSent: props<{ popupWindowId: string, filter: IRecordingsPopupFilter }>(),
        popupFilterReceived: props<{ filter: IRecordingsPopupFilter }>(),
        popupFilterApplied: emptyProps(),
    }
});
